<div class="modal-header">
    <button type="button"
            class="close swapa-close"
            data-dismiss="modal"
            aria-label="Close"
            (click)="activeModal.dismiss()"></button>
</div>
<div class="modal-body" ngbAutofocus>
    <div id="transcript">
    </div>
    <h3>Show Notes:</h3>
    <div [innerHTML]="Transcript | keepHtml">
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-link" (click)="activeModal.close()" data-dismiss="modal">
        Close
    </button>
</div>
